// import { PathParams } from './factory';

export class Parser {
  preparePath(params: any) {
    const { param1, param2, param3, param4, param5, param6, param7 } = params;
    let path = '';
  }
}
